import { useMemo } from "react";

import { Shield } from "components/icons/generated";

import type { MainNavigationItem } from "../types";
import {
  MAIN_NAVIGATION_PRIMARY_MENU_ITEMS,
  MainNavigationPrimaryMenuItemKeys,
} from "./menuItemsPrimary";

const useEnforceGuardrailsGroup = (): MainNavigationItem => {
  return useMemo(
    () => ({
      id: "enforce-guardrails",
      title: "Enforce Guardrails",
      icon: Shield,
      items: [
        {
          items: [
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Spaces],
            MAIN_NAVIGATION_PRIMARY_MENU_ITEMS[MainNavigationPrimaryMenuItemKeys.Policies],
          ],
        },
      ],
    }),
    []
  );
};

export default useEnforceGuardrailsGroup;
